(() => {
  "use strict";

  const globalKey = "__jscaCookieToast";
  if (window[globalKey]?.ready) return;

  const dialog = document.querySelector("[data-cookie-consent]");
  if (!dialog) return;

  window[globalKey] = { ready: true };

  const storageKey = "jsca.cookieToast.acknowledged.v2";
  const designMode = dialog.getAttribute("data-design-mode") === "true";
  const okButton = dialog.querySelector("[data-cookie-consent-ok]");
  const live = document.querySelector("[data-cookie-consent-live]");
  if (!okButton) return;

  const readAck = () => {
    try {
      return window.localStorage.getItem(storageKey) === "1";
    } catch (_) {
      return false;
    }
  };

  const writeAck = () => {
    try {
      window.localStorage.setItem(storageKey, "1");
    } catch (_) {
      // Private mode can block storage; the toast still dismisses for this visit.
    }
  };

  const announce = (text) => {
    if (live) live.textContent = text || "";
  };

  const openToast = () => {
    try {
      if (typeof dialog.showModal === "function") {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute("open", "");
      }
    } catch (_) {
      try {
        dialog.setAttribute("open", "");
      } catch (__) {
        return;
      }
    }

    try {
      okButton.focus({ preventScroll: true });
    } catch (_) {
      try {
        okButton.focus();
      } catch (__) {
        // Focus is best-effort if the host page blocks it.
      }
    }
  };

  const closeToast = () => {
    try {
      if (typeof dialog.close === "function" && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute("open");
      }
    } catch (_) {
      try {
        dialog.removeAttribute("open");
      } catch (__) {
        // Closing is best-effort if the dialog API is incomplete.
      }
    }
  };

  const loadConsentApi = () => {
    try {
      if (typeof window.Shopify?.loadFeatures !== "function") return;
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        () => {},
      );
    } catch (_) {
      // Showing the toast does not depend on the Shopify feature loader.
    }
  };

  const grantConsent = () => {
    try {
      const api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.setTrackingConsent === "function") {
        api.setTrackingConsent(
          { analytics: true, marketing: true, preferences: true },
          () => {},
        );
      }
    } catch (_) {
      // Missing or failing consent APIs still dismiss after acknowledgment.
    }
  };

  const onOk = () => {
    grantConsent();
    writeAck();
    announce("Cookie notice dismissed.");
    closeToast();
  };

  dialog.addEventListener("cancel", (event) => {
    event.preventDefault();
  });

  dialog.addEventListener("pointerdown", (event) => {
    if (event.target === dialog) event.preventDefault();
  });

  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) event.preventDefault();
  });

  okButton.addEventListener("click", onOk);

  if (!designMode && readAck()) return;

  loadConsentApi();
  openToast();
})();
